import { observer } from 'mobx-react';
import React from 'react';
/**
 * IDプロバイダーから、authorization codeを受け取るためのコンポーネント。
 * 認証情報を保存したのち、次画面に遷移する。
 */
export const IdpResponsePage = observer(() => <>認証情報を保存中です。しばらくお待ちください。</>);
